import React, { useEffect, useState } from 'react';
import { FilterDashboardProps } from '.';
import { Flex, Stack, Text } from '@mantine/core';
import Button from '../../elements/Button';
import { useDisclosure, useMediaQuery } from '@mantine/hooks';
import ModalFilter from './ModalFilter';
import { useHistory, useLocation } from 'react-router-dom';
import './styles.scss';

const FilterDashboard: React.FC<FilterDashboardProps> = ({ filterData }) => {
  const smScreen = useMediaQuery('(max-width: 48em)');
  const history = useHistory();
  const location = useLocation();

  const [opened, { open, close }] = useDisclosure(false);
  const [dataFilter, setDataFilter] = useState(null);
  const [values, setValues] = useState(null);

  const queryParamLocation: any = new URLSearchParams(location.search);

  const paramsObject = {
    startDate: queryParamLocation.get('startDate'),
    endDate: queryParamLocation.get('endDate'),
    categoryId: queryParamLocation.get('categoryId')
  };

  const handleFilter = (data: any) => {
    history.push({
      pathname: '/management/dashboard-executive',
      search: `?startDate=${data?.startDate || ''}&endDate=${
        data?.endDate || ''
      }&categoryId=${data?.categoryId || ''}`
    });
    setDataFilter(data);
    close();
    return;
  };

  const handleReset = () => {
    history.push({
      pathname: '/management/dashboard-executive'
    });
    close();
    return;
  };

  useEffect(() => {
    if (
      (filterData && dataFilter) ||
      (filterData && paramsObject?.startDate && paramsObject?.endDate) ||
      paramsObject?.categoryId
    ) {
      setValues(Object.values(filterData).filter((item) => !!item));
    }
  }, [
    filterData,
    dataFilter,
    paramsObject?.startDate,
    paramsObject?.endDate,
    paramsObject?.categoryId
  ]);

  return (
    <>
      <Flex flex={1} gap={16} justify={'flex-start'} align={'flex-end'}>
        <Stack gap={8} flex={1}>
          <Text className="text-xs-semibold">Select filter</Text>
          <Button
            styles={{
              padding: '6px 12px',
              justifyContent: 'center',
              maxWidth: smScreen ? 'unset' : 150
            }}
            full={smScreen}
            onClick={() => open()}
            variant="solid"
          >
            Filter {values && <div className="badge-item">{values.length}</div>}
          </Button>
        </Stack>
      </Flex>
      <ModalFilter
        opened={opened}
        onClose={() => close()}
        onFilter={handleFilter}
        data={dataFilter}
        onReset={handleReset}
      />
    </>
  );
};

export default FilterDashboard;
